import { checkPointTemplateServices } from '../../helpers/services/checkPointTemplate.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper, ddlHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const CHECK_POINT_TEMPLATE_MODULE = 'checkPointTemplate';

// define action 
export const GET_ALL_CHECK_POINT_TEMPLATES = 'getAllCheckPointTemplates';
export const GET_CHECK_POINT_TEMPLATE = 'getCheckPointTemplate';
export const UPDATE_CHECK_POINT_TEMPLATE = 'updateCheckPointTemplate';
export const CREATE_CHECK_POINT_TEMPLATE = 'createCheckPointTemplate';
export const CLONE_CHECK_POINT_TEMPLATE = 'cloneCheckPointTemplate';
export const UPDATE_CHECK_POINT_TEMPLATE_STATUS = 'updateCheckPointTemplateStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_CHECK_POINT_TEMPLATES_REQUEST = "getAllCheckPointTemplates";
const GET_CHECK_POINT_TEMPLATE_REQUEST = "getCheckPointTemplate";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_CHECK_POINT_TEMPLATES]({ commit }, { filter }) {
        checkPointTemplateServices
            .getAllCheckPointTemplates(filter)
            .then(
                (result) => {
                    commit(GET_ALL_CHECK_POINT_TEMPLATES_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },
    async [CLONE_CHECK_POINT_TEMPLATE]({ dispatch }, { filter, data }) {
       await checkPointTemplateServices
            .cloneCheckPointTemplate(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t('message.cloneCheckPointTemplateSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_CHECK_POINT_TEMPLATES, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    async [GET_CHECK_POINT_TEMPLATE]({ commit }, { id }) {
        await checkPointTemplateServices
            .getCheckPointTemplate(id)
            .then(
                (result) => {
                    commit(GET_CHECK_POINT_TEMPLATE_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_CHECK_POINT_TEMPLATE]({ commit }, { data }) {
        commit(REQUEST)
        checkPointTemplateServices
            .updateCheckPointTemplate(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.checkPointTemplate')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_CHECK_POINT_TEMPLATE]({ commit }, { data }) {
        commit(REQUEST)
        checkPointTemplateServices
            .createCheckPointTemplate(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess", [i18n.t('module.checkPointTemplate')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_CHECK_POINT_TEMPLATE_STATUS]({ dispatch }, { filter, data }) {
        checkPointTemplateServices
            .updateCheckPointTemplateStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_CHECK_POINT_TEMPLATES, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Check-point-template-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { processing: true, update: true, create: true };
    },
    [GET_ALL_CHECK_POINT_TEMPLATES_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.text,
                localeName: o.locale_name,
                mediaUrl: o.media_url,
                version: o.version,
                description: o.description,
                answerTypeID: o.answer_type_id,
                remark: o.remark,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time),
                serviceTemplate: o.service_template,
                parentCheckPointTemplate: o.parent_check_point_template,
                subCheckPointTemplate: o.sub_check_point,
                template: o.template,
                answer: o.answer,
            }
        })
    },
    [GET_CHECK_POINT_TEMPLATE_REQUEST](state, data) {
        let o = data.data

        const languages = ddlHelper.getLanguages();
        const answerTypes = ddlHelper.getAnswerTypes();

        var names = null;
        var type = null;
        var answers = null;

        if (o.locale_name != null) {
            names = [];
            Object.keys(o.locale_name.text).forEach(key => {
                names.push({ language: languages.find(lang => lang.code === key), name: o.locale_name.text[key] });
            });
        }
        else {
            names = []
        }

        if (o.answer_type_id != null) {
            type = {
                code: answerTypes.find(type => type.code === o.answer_type_id).code,
                name: answerTypes.find(type => type.code === o.answer_type_id).name
            };
            // type = [];
            // type.push({ code: answerTypes.find(type => type.code === o.answer_type_id).code, name: answerTypes.find(type => type.code === o.answer_type_id).name, });
        }

        answers = o.answer.map((data) => {
            var answerNames = null;
            var answer = null;
            if (data.locale_name != null) {
                answerNames = [];
                Object.keys(data.locale_name.text).forEach(key => {
                    answerNames.push({ language: languages.find(lang => lang.code === key), name: o.locale_name.text[key] });
                });
            }
            else {
                answerNames = []
            }

            answer =
            {
                labelID: data.label != null ? {
                    value: data.label.uuid,
                    text: data.label.text
                } : '',
                uuid: data.uuid,
                isActive: data.is_active,
                description: data.description,
                version: data.version,
                names: answerNames
            }

            return answer;
        });

        state.details = {
            uuid: o.uuid,
            name: o.name,
            names: names,
            localeName: o.locale_name,
            image: o.media_url,
            version: o.version,
            description: o.description,
            answerTypeID: type,
            remark: o.remark,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
            updatedBy: o.updated_by,
            updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time),
            serviceTemplate: o.service_template,
            serviceID: o.service_template != null ? {
                value: o.service_template.uuid,
                text: o.service_template.name
            } : '',
            checkPointtemplateID: o.parent_check_point_template != null ? {
                value: o.parent_check_point_template.uuid,
                text: o.parent_check_point_template.name
            } : '',
            parentCheckPointTemplate: o.parent_check_point_template,
            subCheckPointTemplate: o.sub_check_point,
            template: o.template,
            answer: o.answer,
            answers: answers,
            newAnswers: []
        }
    }
}


